<template>
  <div>
    <div class="basic-info">
      <div class="head-title">基本信息</div>
      <div class="list-label">
        <div class="item-title">用户名</div>
        <div class="item-show">{{ user.nickName }}</div>
        <div class="item-tips">（来自微信同步)</div>
      </div>
      <div class="list-label">
        <div class="item-title">手机号</div>
        <div class="item-show">{{ user.phoneNumber || '未绑定' }}</div>
      </div>
      <div class="list-label">
        <div class="item-title">用户ID</div>
        <div class="item-show">{{ user.id }}</div>
        <a @click="copy" class="item-tips blue" id="copy-btn" :data-clipboard-text="user.id">复制</a>
      </div>
    </div>
    <div class="vip-info">
      <div class="head-title">会员服务</div>
<!--      <div class="list-label">-->
<!--        <div class="item-title">会员权益</div>-->
<!--        <div class="item-show">{{ $_.get($store.state.userLevelList, `${user.userLevel}.label`) }}</div>-->
<!--        <router-link to="/dredgeVip" class="item-tips blue">升级服务</router-link>-->
<!--      </div>-->
      <div class="list-label" v-if="info.isVip">
        <div class="item-title">到期时间</div>
        <div class="item-show">{{ formatDate() }}</div>
        <router-link to="/dredgeVip" class="item-tips blue">续费</router-link>
      </div>
      <div class="list-label">
        <div class="item-title">服务方向</div>
        <div class="item-show">{{ user.hasUserInfo ? '已' : '未' }}提交</div>
<!--        <router-link to="/information/completeInfo" class="item-tips blue">查看</router-link>-->
      </div>
      <div class="list-label">
        <div class="item-title">用户协议</div>
        <router-link to="/information/compact" class="item-tips blue">查看</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import isWeixin from '@/helper/isWeixin';

export default {
  data() {
    return {
      user: {},
      info: {}
    }
  },
  mounted() {
    this.query();
  },
  methods: {
    copy() {
      const clipboard = new ClipboardJS('#copy-btn');
      clipboard.on('success', e => {
        e.clearSelection();
      });
      this.$dialog.alert({
        message: '复制成功'
      })
    },
    query() {
      this.$get({
        road: 'businessNotice',
        params: { senceId: 1002 },
        version: 'v2'
      }).then(res => {
        this.info = res
      })
      this.$store.dispatch('getUserInfo').then(res => {
        this.user = res
      })
    },
    formatDate() {
      let time = this.info.stopTime
      if (time) {
        return moment(time * 1000).format('YYYY-MM-DD')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.basic-info,
.vip-info {
  padding: 0 0.3rem;
  background: #fff;
  margin-bottom: 0.1rem;

  .head-title {
    height: 0.8rem;
    line-height: 0.8rem;
    color: #4a4a4a;
    font-size: 0.28rem;
  }

  .list-label {
    display: flex;
    align-items: center;
    border-top: 0.02rem solid #eef2f7;
    font-size: 0.28rem;
    height: 1.2rem;

    .item-title {
      width: 1.5rem;
      color: #a1aebf;
    }

    .item-show {
      color: #4a4a4a;
    }

    .item-tips {
      flex: 1;
      color: #a1aebf;
      text-align: right;
    }

    .item-tips.blue {
      color: #2a89f4;
    }
  }
}
</style>